import ReactXMLViewer from "react-xml-viewer";

export const XMLViewer = ({ xml }: { xml: string }) => {
  return <ReactXMLViewer xml={xml} />;
};
